import script from "./ExtinguisherVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtinguisherVue.vue?vue&type=script&setup=true&lang=js"

import "./ExtinguisherVue.vue?vue&type=style&index=0&id=29b020b0&lang=scss"

const __exports__ = script;

export default __exports__